import { NGROK } from "../../../../../APIs";
import { apiClient } from "../../../../../utils/apiClient";

export const getClusterTabs = async (payload: any, level: string) => {
    let url = `${NGROK}/api/k8-resources/v1/get?level=${level}`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });
    return data;
}

export const getGCPAllVms = async (latestTenant: string, latestprojectId: string) => {

    let url = `${NGROK}/api/gcp/virtual-machines?tenantName=${latestTenant}&projectId=${latestprojectId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    const flattenedData = Object.values(data).flatMap((item) => item);
    return flattenedData;
};

export const getGCPAllStorages = async (latestTenant: string, latestprojectId: string) => {
    let url = `${NGROK}/api/gcp/storage-buckets?tenantName=${latestTenant}&projectId=${latestprojectId} `;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const getGCPAllDatabases = async (latestTenant: string, latestprojectId: string) => {
    let url = `${NGROK}/api/gcp/databases?tenantName=${latestTenant}&projectId=${latestprojectId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};


export const getAWSAllEC2 = async (latestTenant: string, selectedAwsAccount: string) => {

    let url = `${NGROK}/api/aws/allEC2Instances?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    const flattenedData = Object.values(data).flatMap((item) => item);
    return flattenedData;
};

export const getAWSAllS3 = async (latestTenant: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getAllS3Buckets?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const getAWSAllRDS = async (latestTenant: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getAllRDSInstances?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};



export const getAllAzureResources = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=VIRTUAL_MACHINE&subsId=${subId}`;

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data
};
export const getAllAzureStorage = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=STORAGE_ACCOUNT&subsId=${subId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};
export const getAllAzureDatabase = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=DATABASE&subsId=${subId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};



export const getGCPCluster = async (latestTenant: string, gcpSelectedProjectId: string) => {
    let url = `${NGROK}/api/gcp/kubernetes-clusters?tenantName=${latestTenant}&projectId=${gcpSelectedProjectId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const getAWSClusters = async (latestTenant: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/k8-clusters?tenantName=${encodeURIComponent(latestTenant)}`;
    if (selectedAwsAccount) {
        url += `&accountId=${encodeURIComponent(selectedAwsAccount)}`;
    }
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const getAllAzureClusters = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=AZURE_KUBERNETES&subsId=${subId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};



export const fetchAzureSubscriptionList = async (latestTenant: string) => {
    let url = `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=SUBSCRIPTION`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchAWSAccountList = async (latestTenant: string) => {
    let url = `${NGROK}/api/aws/getAllAccounts?tenantName=${latestTenant}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};


export const publishGCPVMS = async (latestTenant: string, latestprojectId: string, id: string) => {
    let url = `${NGROK}/api/gcp/resource/publishVirtualMachine?tenantName=${latestTenant}&projectId=${latestprojectId}&virtualMachineId=${id}`;
    const data = await apiClient({
        method: "PUT",
        url: url
    });
    return data;
};

export const publishGCPBucket = async (latestTenant: string, latestprojectId: string, id: string) => {
    let url = `${NGROK}/api/gcp/resource/publishBucket?tenantName=${latestTenant}&projectId=${latestprojectId}&bucketId=${id}`;
    const data = await apiClient({
        method: "PUT",
        url: url
    });
    return data;
};

export const publishGCPDatabase = async (latestTenant: string, latestprojectId: string, id: string) => {
    let url = `${NGROK}/api/gcp/resource/publishDatabase?tenantName=${latestTenant}&projectId=${latestprojectId}&databaseId=${id}`;
    const data = await apiClient({
        method: "PUT",
        url: url
    });
    return data;
};


export const publishAzureResource = async (payload: any) => {
    let url = `${NGROK}/api/azureResources/v1/publish`;
    const data = await apiClient({
        method: "PATCH",
        url: url,
        data: payload
    });
    return data;
};


export const publishK8Resource = async (payload: any) => {
    let url = `${NGROK}/api/k8-resources/v1/publish`;
    const data = await apiClient({
        method: "PATCH",
        url: url,
        data: payload
    });
    return data;
};


export const publishAzureCluster = async (payload: any) => {
    let url = `${NGROK}/api/azureResources/v1/publish`;
    const data = await apiClient({
        method: "PATCH",
        url: url,
        data: payload
    });
    return data;
};

export const publishAWSEC2Instance = async (latestTenant: string, selectedAwsAccount: string, arn: string) => {
    let url = `${NGROK}/api/aws/updateEc2InstancePublish?tenantName=${encodeURIComponent(latestTenant)}&instanceARN=${encodeURIComponent(arn)}&accountId=${encodeURIComponent(selectedAwsAccount)}`;
    const data = await apiClient({
        method: "PUT",
        url: url
    });
    return data;
};

export const publishAWSS3Bucket = async (latestTenant: string, selectedAwsAccount: string, bucketName: string) => {
    let url = `${NGROK}/api/aws/publishBucket?tenantName=${latestTenant}&bucketName=${bucketName}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "PUT",
        url: url
    });
    return data;
};

export const publishAWSRDSInstance = async (latestTenant: string, selectedAwsAccount: string, rdsDBInstanceArn: string) => {
    let url = `${NGROK}/api/aws/publishRDSInstances?tenantName=${latestTenant}&arn=${rdsDBInstanceArn}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "PUT",
        url: url
    });
    return data;
};

export const publishAWSCluster = async (id: any) => {
    let url = `${NGROK}/api/aws/${id}/managed`;
    const data = await apiClient({
        method: "PUT",
        url: url,
    });
    return data;
};

export const publishGCPCluster = async (selectedTenantName: string, projectId: string, clusterId: string) => {
    let url = `${NGROK}/api/gcp/resource/publishKubernetesCluster?tenantName=${selectedTenantName}&projectId=${projectId}&gcpClusterId=${clusterId}`;
    const data = await apiClient({
        method: "PUT",
        url: url,
    });
    return data;
};
